<template>
  <div class="active-modal-mask">
      <div class="active-modal-wrapper">
        <div class="active-modal-container">

          <div class="active-modal-header">
            <div>
              <h5>Límite de contenidos activos</h5>
            </div>
          </div>

          <div class="active-modal-body">
            <p>Haz llegado al límite de contenidos activos, para poder activar un nuevo contenido debes desactivar un contenido activo.</p>
            <p>Contenido activo:</p>
            <ul class="card">
              <li class="img-item">
                <div class="img-content">
                  <img :src="imageUrl+item.images" alt="">
                </div>
              </li>
              <li class="title-descr">
                <p class="title">{{item.title}}</p>
                <p class="description">{{item.description}}</p>
              </li>
              <li class="category">
                    <ul>
                    <li class="category" :class="item.category[0].id==1 ? 'active' : ''" v-if="item.category[0].id==1">
                      <span class="img-cat category-1" :class="item.category[0].id==1 ? 'active-cat' : ''"></span>
                      <p class="category-name" v-if="item.category[0].id==1">Tarjetas</p>
                    </li>
                    <li class="category" :class="item.category[0].id==2 ? 'active' : ''" v-if="item.category[0].id==2">
                      <span class="img-cat category-2" :class="item.category[0].id==2 ? 'active-cat' : ''"></span>
                      <p class="category-name" v-if="item.category[0].id==2">Inversiones</p>
                    </li>
                    <li class="category" :class="item.category[0].id==3 ? 'active' : ''" v-if="item.category[0].id==3">
                      <span class="img-cat category-3" :class="item.category[0].id==3 ? 'active-cat' : ''"></span>
                      <p class="category-name" v-if="item.category[0].id==3">Seguros</p>
                    </li>
                  </ul>
                </li>
              <li class="interaction" v-if="item.action_type==1">Enlace</li>
              <li class="interaction" v-if="item.action_type==2">Mail</li>
              <li class="interaction" v-if="item.action_type==3">Contacto</li>
              <!-- <li class="start-end-date">
                <p>del {{item.init_date}}</p>
                <p>al {{item.end_date}}</p>
              </li> -->
            </ul>
            <p>Selecciona el contenido que deseas desactivar:</p>
            <div class="active-content">

              <ul class="card" v-for="(offer,key) in data" :key="key">
                <li class="status">
                  <label class="switch">
                    <input type="checkbox" v-bind:checked="offer.is_active" @change="handleActiveChange(offer)">
                    <span class="slider"></span>
                  </label>
                </li>
                <li class="title-descr">
                  <p class="title">{{offer.title}}</p>
                  <p class="description">{{offer.description}}</p>
                </li>
                
                <li class="category">
                    <ul>
                    <li class="category" :class="offer.category[0].id==1 ? 'active' : ''" v-if="offer.category[0].id==1">
                      <span class="img-cat category-1" :class="offer.category[0].id==1 ? 'active-cat' : ''"></span>
                      <p class="category-name" v-if="offer.category[0].id==1">Tarjetas</p>
                    </li>
                    <span class="divider"></span>
                    <li class="category" :class="offer.category[0].id==2 ? 'active' : ''" v-if="offer.category[0].id==2">
                      <span class="img-cat category-2" :class="offer.category[0].id==2 ? 'active-cat' : ''"></span>
                      <p class="category-name" v-if="offer.category[0].id==2">Inversiones</p>
                    </li>
                    <span class="divider"></span>
                    <li class="category" :class="offer.category[0].id==3 ? 'active' : ''" v-if="offer.category[0].id==3">
                      <span class="img-cat category-3" :class="offer.category[0].id==3 ? 'active-cat' : ''"></span>
                      <p class="category-name" v-if="offer.category[0].id==3">Seguros</p>
                    </li>
                  </ul>
                </li>
              
              <li class="interaction" v-if="offer.action_type==1">Enlace</li>
              <li class="interaction" v-if="offer.action_type==2">Mail</li>
              <li class="interaction" v-if="offer.action_type==3">Contacto</li>
              <li class="start-end-date">
                <p>del {{offer.init_date}}</p>
                <p>al {{offer.end_date}}</p>
              </li>
              </ul>
              
              
            </div>
          </div>
          <div class="active-modal-footer">
            <button class="button md ghost black" @click="hideActiveModal">
              <p>Cancelar</p>
            </button>
            <button class="button md primary" @click="hideActiveModal">
              <p>Aceptar</p>
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'activeContent-modal',
  components:{},
  props: {
    data: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
  },
  methods: {
    hideActiveModal: function(){
      this.$emit('closeActiveModal');
    },
    handleActiveChange: function(offer){
      offer.is_active = !offer.is_active
      print(offer)
      this.updateActiveOffer({'offer_id':offer.id, 'is_active':offer.is_active, 'profile_id':offer.profile_id[0]})
        .then(r => {
            if(r==false){
              offer.is_active = !offer.is_active
            }
        }, err => {
            console.log(err)
        })
    },
    ...mapActions('offers', [
          'updateActiveOffer'

        ])
  },
  computed: {
        imageUrl: function() {
            return process.env.VUE_APP_CORE_HOST
        }
    }
}
</script>

<style lang="sass">
.active-modal-mask
  font-family: Montserrat
  position: fixed
  z-index: 99998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .5)
  display: table
  transition: opacity .3s ease
  text-align:center
.active-modal-wrapper
  display: table-cell
  vertical-align: middle
.active-modal-container
  max-width: 700px
  border-radius: 8px
  box-shadow: 0 2px 10px 0 rgba(173, 182, 212, 0.45)
  background-color: #ffffff
  margin: 0 auto
  padding: 24px 12px
  transition: all .3s ease
  @media (max-width: $tablet)
    max-width: calc(100% - 40px)
    margin: 0 8px
.active-modal-header
  text-align: center
.active-modal-header i
  color: #c90b2f
  font-size: 72px
.active-modal-body 
  text-align: left
  margin: 20px 0
.active-modal-body p
  font-size: 16px
  font-family: $body-font
  margin-bottom: 16px
.active-modal-footer
  width: 100%
  display: flex
  justify-content: center
.active-modal-footer .button
  margin: 8px
.modal-enter
  opacity: 0
.modal-leave-active
  opacity: 0
.modal-enter .active-modal-container,
.modal-leave-active .active-modal-container
  -webkit-transform: scale(1.1)
  transform: scale(1.1)
.active-content
  margin: 24px 0px
.active-modal-body
  .card
    box-sizing: border-box
    padding: $xxs
    margin: 4px 8px
    border-radius: 4px
    align-items: center
    display: flex
    flex-direction: row
    justify-content: flex-start
    font-family: $title-font
    font-size: 10px
    border: 1px solid rgba(0,0,0,0)
    &:hover
      border: 1px solid #E5EDF4
      box-sizing: border-box
    li
      list-style-type: none
      text-align: center
    div
      display: flex
      flex: row wrap
    p
      font-size: 10px
      margin-bottom: 2px
    .img-item
      width: 56px
      display: flex
      justify-content: center
      .img-content
        width: 56px
        height: 56px
        background-size: cover
        display: flex
        position: relative
        overflow: hidden
        img 
          width: 100%
          height: auto
          display: flex
          align-self: center
    .status
      width: calc(100%/12)
      display: block
      padding: 0
    .title-descr
      height: 56px
      display: flex
      flex-direction: column
      align-content: flex-start
      padding: 0 $xs
      width: calc(100%/3)
      .title
        font-weight: bold
        text-align: left
      .description
        font-weight: 300
        text-align: left
    .category
      display: block
      flex-direction: column
      width: calc(100%/6)
      li
        width: 100%
        display: flex
        flex-direction: column
      .icon
      display: block
      .category-name
    .interaction
      width: calc(100%/6)
      margin: 0 $xs
    .start-end-date
      width: calc(100%/6)
      box-sizing: border-box
      padding: 0 0 0 $sm

.switch
  position: relative
  display: inline-block
  width: 48px
  height: 24px
.switch input
  opacity:  0
  width: 0
  height: 0
.slider
  position: absolute
  cursor: pointer
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: #ccc
  transition: 300ms
  border-radius: 34px
.slider:before
  position: absolute
  content: ""
  height: 20px
  width: 20px
  left: 2px
  bottom: 2px
  background: white
  transition: 300ms
  border-radius: 100%
input:checked + .slider
  background: $secondary
input:focus + .slider
  box-shadow: 0 0 1px red
input:checked + .slider:before
  transform: translateX(24px)
</style>


